<template>
  <div class="home-container">
    <div class="sidebar">
      <div class="sidebar-header">
        <h3>后台管理</h3>
      </div>
      <el-menu :default-active="activeMenu" class="sidebar-menu" @select="handleMenuSelect">
        <el-menu-item index="/home/carousel">
          <i class="el-icon-picture-outline"></i>
          <span slot="title">轮播图管理</span>
        </el-menu-item>
        <el-menu-item index="/home/article">
          <i class="el-icon-document"></i>
          <span slot="title">文章发布</span>
        </el-menu-item>
        <el-menu-item index="/home/tab-config">
          <i class="el-icon-menu"></i>
          <span slot="title">Tab配置</span>
        </el-menu-item>
        <el-menu-item index="logout">
          <i class="el-icon-switch-button"></i>
          <span slot="title">退出登录</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="main-content">
      <div class="content-header">
        <h2>{{ pageTitle }}</h2>
      </div>
      <div class="content-body">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      activeMenu: '/home/carousel',
      pageTitle: '轮播图管理'
    }
  },
  created() {
    this.updatePageTitle()
  },
  watch: {
    $route() {
      this.updatePageTitle()
    }
  },
  methods: {
    handleMenuSelect(key) {
      if (key === 'logout') {
        this.$confirm('确定要退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('isAuthenticated')
          this.$router.push('/login')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出'
          })
        })
      } else {
        this.$router.push(key)
      }
    },
    updatePageTitle() {
      const path = this.$route.path
      if (path.includes('carousel')) {
        this.pageTitle = '轮播图管理'
        this.activeMenu = '/home/carousel'
      } else if (path.includes('article')) {
        this.pageTitle = '文章发布'
        this.activeMenu = '/home/article'
      } else if (path.includes('tab-config')) {
        this.pageTitle = 'Tab配置'
        this.activeMenu = '/home/tab-config'
      }
    }
  }
}
</script>

<style scoped>
.home-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.sidebar {
  width: 200px;
  background-color: #304156;
  color: #fff;
}

.sidebar-header {
  padding: 20px;
  background-color: #263445;
  text-align: center;
}

.sidebar-header h3 {
  margin: 0;
  color: #fff;
}

.sidebar-menu {
  background-color: #304156;
  border-right: none;
}

.sidebar-menu .el-menu-item {
  color: #bfcbd9;
}

.sidebar-menu .el-menu-item:hover {
  background-color: #409EFF;
  color: #fff;
}

.sidebar-menu .el-menu-item.is-active {
  background-color: #409EFF;
  color: #fff;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-header {
  padding: 20px;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
}

.content-header h2 {
  margin: 0;
  color: #303133;
}

.content-body {
  flex: 1;
  padding: 20px;
  background-color: #f5f7fa;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue